import cn from 'classnames';
import React, { FC, memo, useCallback } from 'react';

import { Button, Typography } from '@mui/material';

import { TAG_TITLE } from '@constants/vaults/common.constants';

import { Option } from '@app-types/common/common.types';

import useStyles from './styles.module';

interface Props extends Option {
  isActive: boolean;
  onClickTab: (value: string | number) => void;
  disabled?: boolean;
}

const FilterTab: FC<Props> = ({
  isActive,
  label,
  icon,
  value,
  onClickTab,
  tagType,
  disabled = false,
  ...restProps
}) => {
  const { classes } = useStyles({ isActive, tagType, disabled });

  const handleClick = useCallback(() => {
    onClickTab(value);
  }, [onClickTab, value]);

  return (
    <Button
      className={cn(classes.btn, { [classes.activeBtn]: isActive })}
      onClick={handleClick}
      disableRipple
      disabled={disabled}
      {...restProps}
    >
      <Typography variant="subtitle2" textTransform="initial">
        {label}
      </Typography>
      <span className={classes.icon}>{icon}</span>
      {tagType && (
        <Typography variant="caption2" className={classes.tagType}>
          {TAG_TITLE[tagType]}
        </Typography>
      )}
    </Button>
  );
};

export default memo(FilterTab);
